import { IColorSpecifiedFeature } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IPaintStyleOnEditingPropertyEditable {
  paintStyleOnEditing(): IPropertyEditable<IColorSpecifiedFeature>;
}

export function instanceOfIPaintStyleOnEditingPropertyEditable(instance: any): instance is IPaintStyleOnEditingPropertyEditable {
  return instance
      && instance.paintStyleOnEditing
      && instanceOfIPropertyEditable<IColorSpecifiedFeature>(instance.paintStyleOnEditing());
}
